import { render, staticRenderFns } from "./CustomerPanelV2026.vue?vue&type=template&id=043cccda&scoped=true"
import script from "./CustomerPanelV2026.vue?vue&type=script&lang=js"
export * from "./CustomerPanelV2026.vue?vue&type=script&lang=js"
import style0 from "./CustomerPanelV2026.vue?vue&type=style&index=0&id=043cccda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043cccda",
  null
  
)

export default component.exports